import { Property } from "csstype";
import styled from "styled-components";

export const StyledSpan = styled.span<{
  fontWeight?: Property.FontWeight;
}>`
  font-weight: ${({ fontWeight }) => fontWeight};
`;
